import _ from 'lodash';
import Device from '../Device';

const questions = [{
  model: 'neovolta',
  type: 'oauth',
  name: 'neovolta',
  label: 'step3OauthDeviceNeoVolta',
  showNext: false,
  required: true,
  advanceOnEnter: true,
  advanceOnValue: true,
  update: values => ({
    additionalFields: {
      type: 'gravity',
      mfg: 'neovolta',
      tags: JSON.stringify(_.get(values, 'tags') || {}),
      deviceTags: JSON.stringify(_.get(values, 'deviceTags') || {}),
    },
  }),
}];

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const NeoVolta = new Device('neovolta', { mfg: 'neovolta', questions, addDevice });

export default NeoVolta;
